import React, { useState } from 'react';
import { Button, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Drawer from '@material-ui/core/Drawer';
import { withStyles } from '@material-ui/core';
import Icon from "storybookComponents/Icon";
import FeedBack from "./Feedback"
import FeedBackIcon from "./feedback.svg"
import FeedBackIconBlue from "./feedback-blue.svg"
import Tooltip from 'storybookComponents/Tooltip';
import moment from "moment";
import "./index.css"


const styles = () => ({
  root: {
    color: "#999999"
  },
  confirmBody: {
    width: 500,
    padding: "20px",
    paddingTop: 0
  },
  confirmHeader: {
    width: 460,
    fontSize: 16,
    paddingBottom: 12,
  },
  latestHeader: {
    color: "333333",
  },
  pastHeader: {
    color: "rgba(51, 51, 51, 0.75)",
  },
  cancelButton: {
    height: 40,
    width: 102,
    marginRight: 12,
  },
  disapproveButton: {
    fontWeight: "100 !important",
    height: 40,
    width: 165
  },
  feedbackStyle: {
    fontSize: 12,
    color: "gray",
    marginBottom: 4
  },
  confirmFeedback: {
    width: " 460px",
    minHeight: "144px",
    resize: "none",
    padding: "8px 12px",
    fontSize: "16px",
  },

  latestFeeback: {
    borderRadius: 4,
    color: "black",
    background: "#F9F9F9",
  },
  pastFeeback: {
    border: "1px solid #DADADA",
    color: "rgba(51, 51, 51, 0.75)",
  },

  mainBody: {
    maxWidth: "auto"
  },
  info: {
    "&&.popover": {
      maxWidth: 600
    }
  },
  flexBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 20px",
    borderBottom: "1px solid #DADADA",
    fontSize: 20,
    marginBottom: 24,

  },
  drawerPaper: {
    background: "white"
  },
  horizontalBar: {
    height: 1,
    borderBottom: "1px solid #DADADA",
    width: "100%",
  },
  bottom: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 20px",
    marginTop: 12,
    marginBottom: 18
  },
  text: {
    padding: "0px 10px"
  },
  verticalBar: {
    height: 34,
    width: 1,
    background: "#EEEEEE",
    margin: "0px 12px",
  },
  iconClass: {
    display: "flex",
    alignItems: "center",
    justifyContent: 'center',
    cursor: "pointer",
    "&&:hover": {
      color: "blue"
    }
  },
  closeIcon: {
    cursor: "pointer",
  }
})

const dummyArray = [
  {
    time: "16 Jan 2021, 9:30",
    approverName: "IQ Approver",
    disapproveReason: "disapproveReason"
  },
  {
    time: "16 Jan 2021, 9:30",
    approverName: "IQ Approver",
    disapproveReason: "disapproveReason"
  },
  {
    time: "16 Jan 2021, 9:30",
    approverName: "IQ Approver",
    disapproveReason: "disapproveReason"
  }
  ,
  {
    time: "16 Jan 2021, 9:30",
    approverName: "IQ Approver",
    disapproveReason: "disapproveReason"
  }
]

const Info = ({ classes, approverName, disapprovedAt, disapproveReason, ...rest }) => {
  const [popoverOpen, setPopoverOpen] = useState(true);
  const toggle = () => setPopoverOpen(!popoverOpen);
  if (!approverName || !disapproveReason) return null

  const FeedBackList = (item, index) => (
    <FeedBack classes={classes} time={item.time} horizontalBar={dummyArray.length > 1} latest={index === 0} disapproveReason={item.disapproveReason} approverName={item.approverName} />
  )
  return (
    <div className={classes.info}>
      {/* <InfoOutlinedIcon className={classes.root} id="Popover2" /> */}
      <Tooltip tooltip_text="View disapproval feedback/comments">
        <div className={classes.iconClass}>
          <img src={FeedBackIcon}
            onMouseOver={e => (e.currentTarget.src = FeedBackIconBlue)}
            onMouseOut={e => (e.currentTarget.src = FeedBackIcon)}
            className={classes.root} onClick={toggle} />
          {/* <InfoOutlinedIcon className={classes.root} onClick={toggle} /> */}
          <div className={classes.verticalBar}></div>
        </div>
      </Tooltip>
      <Drawer anchor="right" open={popoverOpen} onClose={toggle} classes={{
        paper: classes.drawerPaper,
      }}>
        <div >
          <div className={classes.flexBox}>
            Approver Feedback
            <div className={classes.closeIcon}>
              <Icon onClick={toggle} type="icon-e-remove" size="lg" />
            </div>

          </div>
          {
            // dummyArray.map(FeedBackList)
            <FeedBack classes={classes} time={moment(new Date(disapprovedAt)).format('DD MMM YYYY, hh:mm A')} latest disapproveReason={disapproveReason} approverName={approverName} />
          }

        </div>
      </Drawer>
      {/* <Popover className="info-popover" trigger="legacy" placement="bottom" isOpen={popoverOpen} target="Popover2" toggle={toggle}>
        <div className={classes.confirmBody} >
          <div className={classes.confirmHeader} ><b>This event has been disapproved by {approverName}</b></div>
          <div>
            <div className={classes.feedbackStyle}>Feedback</div>
            <div className={classes.confirmFeedback} dangerouslySetInnerHTML={{ __html: disapproveReason.replace(/\n/g, "<br />") }}></div>
          </div>
        </div>
      </Popover> */}
    </div>
  );
}

export default (withStyles(styles)(Info))